import request from '@/utils/request'

// 注册
export function common_aes(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/register',
    method: 'post',
    data
  })
}
